const convertMimeToExtension = (mimeType) => {
  switch (mimeType) {
    case "image/jpg":
      return "jpg"
    case "image/jpeg":
      return "jpeg"
    case "image/png":
      return "png"
    case "image/webp":
      return "webp"
    case "image/gif":
      return "gif"
    case "image/svg+xml":
      return "svg"
    case "image/apng":
      return "apng"
    case "image/apng":
      return "apng"
    case "image/avif":
      return "avif"
    case "video/mp4":
      return "mp4"
    case "application/pdf":
      return "pdf"
    case "application/msword":
      return "doc"
    case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
      return "docx"
    case "application/vnd.ms-excel":
      return "xls"
    case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
      return "xlsx"
    case "application/vnd.ms-powerpoint":
      return "ppt"
    case "application/vnd.openxmlformats-officedocument.presentationml.presentation":
      return "pptx"
    default:
      return mimeType
  }
}

export default convertMimeToExtension
